import React, { useEffect, useState } from 'react'
import '../styles/program.scss'



export default function Dates({ datearr, selectedDate, setSelectedDate, menuClickHandler, showItem }) {
    const [isOpen, setIsOpen] = useState(false);

    // ----------SELECTED DATE CALCULATIONS---------------------
   
    function handleDayClick(days) {
     setIsOpen((current) => !current);

        if (days == selectedDate) {
            setSelectedDate()
        }
        else setSelectedDate(days)
    }
 

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }


   
    return (
        
        <div className=" dropdownContainer">
                   
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
                zIndex: isOpen ? 99 : 1
            }}>
                            <div
                                style={{
                                    position: "relative",
                                   // padding: "5px 8px",
                                    boxSizing: "border-box",
                         //   height: "31px",
                          //  borderBottom: isOpen ? '1px solid grey' : ''
                                }}
                    >
                    <p className='dropdownTitle'> {selectedDate ? selectedDate : ' Dato '} </p>
                        
                             
                    <button className='chooseBtn'
                        onClick={() => { handleRegionArrrow(); menuClickHandler('dato') }}
                                    
                                >
                        <p className={showItem === 'dato' ? "rotate down" : "rotate "}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                </div>
                {showItem === 'dato' && (
                    <div className={`scroll  ${showItem === "dato" ? 'dropdown_show' : null}`}
                        style={{minHeight:'310px'} }  
                        >
                            {datearr.sort(function (a, b) {
                                let curr = a.split('-').reverse().join();
                                let prev = b.split('-').reverse().join();
                                return curr < prev ? -1 : (curr > prev ? 1 : 0);
                            }).map((date,index) => (
                                  <div key={index} style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px",
                                    padding: "10px 10px 10px 16px", borderRadius:'6px',
                                  //  borderRight: '1px solid #757575',
                                    width: '95%',
                                    backgroundColor: datearr.length && selectedDate == date ? '#3E455C' : ''
                                  }} onClick={() => handleDayClick(date)}>
                                    <p className='dropdowns-lists'>{date}</p>
                                   
                                        {selectedDate == date ?

                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                        </svg>}
                                   
                                </div>
                             )) }
                            
                           
                                </div>
                            )}
                        </div>
                    
                    
                </div>
               

           
        )
}